import { apiGet } from '../../../utils';
import moment from 'moment';


export function getAllHeatPumpDevicesAPI(filters) {
    let arr = []

    for (const [key, value] of Object.entries(filters)) {

        if (key === "isOpen") continue

        if (typeof value !== "number" && !value?.length) continue

        if (key === "installation_date") {
            if (value[0] == null) continue
            arr.push({
                key,
                value: moment(filters.installation_date[0]).format("DD-MM-YYYY"),
                end_value: moment(filters.installation_date[1]).format("DD-MM-YYYY"),
                type: 'single'
            })
        }
        else if (["device_status", "status","connection_type"].includes(key)) {
            arr.push({ key, value, type: 'multi' })
        } else {
            arr.push({ key, value: encodeURIComponent(value), type: "single" })
        }
    }
    return apiGet(`/api/heat-pump/list?filter=${JSON.stringify(arr)}`, null, 'safelink')

}

export function getSingleHeatPumpDeviceAPI(id) {
    return apiGet(`/api/heat-pump/info/${id}`, null, 'safelink')
}

export function getHeatPumpDeviceHistoryBySerialNoAPI(mac_address) {
    return apiGet(`/api/heat-pump/install-history?mac_address=${mac_address}`,null,'safelink')
}

